import { render, staticRenderFns } from "./NewDevice.vue?vue&type=template&id=04052ba2"
import script from "./NewDevice.vue?vue&type=script&lang=js"
export * from "./NewDevice.vue?vue&type=script&lang=js"
import style0 from "./NewDevice.vue?vue&type=style&index=0&id=04052ba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports